import * as React from "react";
import type { ToastOptions } from "@clintonelec/react-storybook";
import { toast } from "@clintonelec/react-storybook";
import { isArray } from "lodash";
import type { ErrorType } from "Interfaces";
import type { SerializedError } from "@reduxjs/toolkit";

export enum NotificationType {
	SUCCESS = "success",
	ERROR = "error",
	INFO = "info",
	WARNING = "warning"
}

export function notify(
	type: NotificationType, title: string, content?: React.ReactNode, durationMilliseconds?: number | false,
	toastOptions?: ToastOptions
) {
	if (content) {
		const complexContent = (
			<React.Fragment>
				<div className="cec-notification-title">
					{ title }
				</div>
				<div className="cec-notification-content">
					{ content }
				</div>
			</React.Fragment>
		);

		return toast[type](complexContent, { autoClose: durationMilliseconds, ...toastOptions });
	}

	toast[type](title, { autoClose: durationMilliseconds, ...toastOptions });
}

export function notifyError(error: SerializedError) {
	if (!error?.message) {
		notify(NotificationType.ERROR, "An unknown error occurred");

		return;
	}

	try {
		const parsedErrors = JSON.parse(error?.message);

		if (isArray(parsedErrors)) {
			parsedErrors.forEach((parsedError: ErrorType) => {
				notify(NotificationType.ERROR, parsedError.title, parsedError.detail);
			});

			return;
		}

		notify(NotificationType.ERROR, parsedErrors.title, parsedErrors.detail);
	} catch {
		notify(NotificationType.ERROR, "An unknown error occurred");

		return;
	}
}
